import { ChangeEvent } from 'react';
import { Autocomplete, CircularProgress, MenuItem } from '@mui/material';
import { Currency } from '../../../../../../pages/dashboard/payments/interfaces/Currency';
import { formatDecimalNumber } from '../../../../../../utils/helper';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import CustomTextField from '../../../../../CustomTextInput';
import Signature from '../../../../../signature/signature';
import {
    Proforma,
    ProformaFormErrors
} from '../../../../../../interfaces/Proforma';

interface ProformaStepTwoFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: Proforma;
    errors: ProformaFormErrors;
    currencies: Currency[];
    loadingCurrencies: boolean;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
    totalAmount: number;
}

const StepTwo = ({
    updateField,
    payload,
    errors,
    currencies,
    loadingCurrencies,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalAmount
}: ProformaStepTwoFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <Autocomplete
                value={payload.currencyCodeValue as unknown as Currency}
                // inputValue={payload.currencyCode}
                placeholder='Currency'
                disableClearable
                id='send-currency'
                renderInput={(params) => (
                    <CustomTextField
                        params={params}
                        value={payload.currencyCode}
                        label='Select Currency'
                        placeholder='Currency'
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: loadingCurrencies && (
                                <>
                                    <CircularProgress size={20} />
                                    {params.InputProps.endAdornment}
                                </>
                            )
                        }}
                    />
                )}
                noOptionsText={'No data available'}
                renderOption={(props, option) => (
                    <MenuItem
                        {...props}
                        value={option.name}
                        key={`countries-${option.id}`}
                    >
                        {option.name}
                    </MenuItem>
                )}
                getOptionLabel={(option) => option.name}
                onChange={(_, value: Currency) => {
                    if (value !== null) {
                        updateField('currencyCode', value.currencyCode);
                        updateField(
                            'currencyCodeValue',
                            value as unknown as string
                        );
                    }
                }}
                options={currencies}
            />
            <CustomTextField
                disabled
                id='proformainvoice-totalAmount'
                label='Total Amount'
                name='totalAmount'
                value={formatDecimalNumber(totalAmount)}
            />

            <CustomTextField
                error={!!errors?.placeOfIssue}
                helperText={
                    errors?.placeOfIssue ? errors?.placeOfIssue : undefined
                }
                required
                value={payload?.placeOfIssue}
                id='quotation-placeOfIssue'
                label='Place of Issue'
                name='placeOfIssue'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('placeOfIssue', e.target.value);
                }}
            />

            <Customdatepicker
                value={
                    payload?.issuedDate !== undefined
                        ? payload?.issuedDate
                        : null
                }
                id='quotation-issuedDate'
                label='Issued Date'
                name='issuedDate'
                updateField={updateField}
                error={!!errors?.issuedDate}
                helperText={errors?.issuedDate}
            />

            <CustomTextField
                error={!!errors?.signatoryCompany}
                helperText={errors?.signatoryCompany}
                required
                value={payload?.signatoryCompany}
                id='proformainvoice-signatoryCompany'
                label='Signatory Company'
                name='signatoryCompany'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('signatoryCompany', e.target.value);
                }}
            />

            <CustomTextField
                error={!!errors?.nameOfAuthorisedSignatory}
                helperText={errors?.nameOfAuthorisedSignatory}
                required
                id='proformainvoice-nameOfAuthorisedSignatory'
                label='Name of Authorized Signature'
                name='nameOfAuthorisedSignatory'
                value={payload?.nameOfAuthorisedSignatory}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('nameOfAuthorisedSignatory', e.target.value);
                }}
            />

            <CustomTextField
                multiline
                rows={2.8}
                height={150}
                id='proformainvoice-additionalInformation'
                label='Additional Information'
                name='additionalInformation'
                value={payload?.additionalInformation}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('additionalInformation', e.target.value);
                }}
            />

            <Signature
                name='signatureUrl'
                updateField={updateField}
                setSignatureUrlBase64={setSignatureUrlBase64}
                signatureUrlBase64={signatureUrlBase64}
            />
        </div>
    );
};

export default StepTwo;
